import {GqlModel, GqlModelOperator, GqlQueryModel} from "../graphql/graphql.model";
import gql from "graphql-tag";

export class CronGqlModel extends GqlQueryModel {
  static mapper: GqlModelOperator<CronGqlModel> = GqlModel.buildMapper(CronGqlModel, "cron");

  static query: any = gql`
subscription cron {
  cron {
    __typename
    ... on CronSuccess {
      name
      message
    }
    ... on CronFailure {
      name
      message
    }
    ... on CronInfo {
      name
      message
      step
      totalSteps
      level
    }
  }
}
  `;

  name: string;
  message: string;

  constructor(data: any) {
    super(data);
    data = data || {};

    this.name = data.name;
    this.message = data.message;
  }
}

export class CronInfoGqlModel extends CronGqlModel {
  type = "info";
  step: number;
  totalSteps: number;
  level: string;

  constructor(data: any) {
    super(data);
    data = data || {};

    this.step = data.step;
    this.totalSteps = data.totalSteps;
    this.level = data.level || "info";
    this.type = this.level;
  }
}

export class CronSuccessGqlModel extends CronGqlModel {
  type = "success";
}

export class CronFailureGqlModel extends CronGqlModel {
  type = "failure";
}

CronGqlModel.register("CronInfo", CronInfoGqlModel);
CronGqlModel.register("CronSuccess", CronSuccessGqlModel);
CronGqlModel.register("CronFailure", CronFailureGqlModel);
